module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "historical-legacy-page"
    }
  }, [(!this.leak_detail) ? _c('div', {
    staticClass: "form-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option2
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'desde')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.desdeText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.option
    },
    on: {
      "change": function($event) {
        return _vm.validate($event, 'hasta')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "10px",
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.hastaText))])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-c', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "ductos",
      "id": "ductosHistorico",
      "options": _vm.ductos.map(function (ducto) { return ({
        name: ducto.ducto,
        value: ducto.id
      }); }),
      "index": "text",
      "placeholder": "DUCTO"
    },
    on: {
      "changeSelect": function($event) {
        return _vm.selectEvent($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('button', {
    staticClass: "btn btn-default waves-effect",
    class: [_vm.desde === '' || _vm.ducto === '' || _vm.validation === false ? 'disabled' : ''],
    staticStyle: {
      "margin-left": "0"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("\r\n\t\t\t\t\tBuscar\r\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('json-ex', {
    attrs: {
      "data": _vm.jsonData,
      "fields": _vm.jsonFields,
      "name": ("HDA-" + _vm.desde + "-" + _vm.hasta + ".xls"),
      "meta": _vm.jsonMeta
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [_c('google-maps', {
    ref: "map",
    attrs: {
      "mcStyle": _vm.mcStyle,
      "mcClass": "half",
      "wStyle": _vm.wStyle
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-center"
  }, _vm._l((_vm.jsonFields), function(row, key, index) {
    return (row !== 'Id') ? _c('th', {
      key: key
    }, [_vm._v("\r\n\t\t\t\t\t\t\t" + _vm._s(key) + "\r\n\t\t\t\t\t\t")]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.historicoMiddlePoints) || _vm.historico), function(row, key) {
    return _c('tr', {
      key: key,
      staticClass: "info",
      class: {
        selectedRow: _vm.selectedEventRow && row.id === _vm.selectedEventRow.id
      },
      attrs: {
        "id": 'alarm-' + key
      },
      on: {
        "click": function($event) {
          return _vm.onSelectRow(row)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.fecha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.hora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lat.toFixedDown(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lng.toFixedDown(4)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.km))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.estado))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.municipio))])])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "hidden",
    attrs: {
      "id": "loading-btn",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#loading-modal-modal"
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": _vm.info.modalName,
      "cclass": "transparent"
    }
  }, [_c('loading-modal', {
    attrs: {
      "info": _vm.info
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("CONSULTA DE EVENTOS (LEGACY)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-border text-primary",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14dce9b6","hasScoped":true}!./src/components/HistoricalLegacy/template.html
// module id = 1686
// module chunks = 6